<template>
  <div name="access">

        <div class="modal-container bg-white w-9/12 mt-6 mx-10 rounded s z-50 h-1/2  ">
            <div class="pt-2">
            <slot name="header">
      
             <h2 class="text-2xl  text-pink-red">{{title}}</h2>

            </slot>
          </div>
          <div class="h-screen overflow-y-auto pt-4">
            <slot name="body">
                   <section class="py-2">
                         {{message}}
                        </section>

                          <section>
                          If you wish to discuss / upgrade your current access to more features such as custom outcomes or full custom curriculum entries please contact us below. 
                        </section>
                        <section class="py-2">
                          <strong>
                          Please contact us:
                          Email: <a href="mailto:info@primarypepassport.co.uk">info@primarypepassport.co.uk</a> 
                          or Telephone: 0800 055 6550 
 
                        </strong>
                        </section>

            </slot>
          </div>

          <div class="modal-footer">
               <slot name="footer">
            </slot>
          </div>
        </div>



  </div>
</template>

<script>
export default {
  name: "access",
  props: ["blocktype"],
  computed: {
    title() {
      if (this.blocktype == "unit") {
        return "NO FREE Custom Units available";
      } else if (this.blocktype == "outcome") {
        return "You do not have access to the Outcomes module";
      } else if (this.blocktype == "trial") {
        return "This feature is not available to Trial users";
      } else if (this.blocktype == "config") {
        return "You do not have access to the Configuration module";
      } else {
         return "You do not have access to this module";
      }
    },
    message() {
      if (this.blocktype == "unit") {
        return "All full customers get 12 FREE custom units to use within our system";
      } else if (this.blocktype == "outcome") {
        return "This is an extra add-on module. To add custom outcomes requires an upgrade to your account.";
      } else if (this.blocktype == "trial") {
        return "This feature is not available to Trial users";
      } else if (this.blocktype == "config") {
        return "To add custom configuration requires an upgrade to your account.";
      } else {
         return "To add this module you will require an upgrade to your account.";
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  opacity: 0.8 !important;
  text-transform: underline !important;
}

section.form {
  border: 1px solid #eeedee !important;
}

.card-title {
  color: #f56a6a;
}
</style>
